<template>
  <div>
    <MyGridLayout :layout-data="layoutData" v-if="isGridShow"/>
    <div id="dataset_svg_table">
      <div v-show="this.SpatialDE.length !== 0">
        <h3>
        <span>
          SV genes identified by SpatialDE(Q-value	&lt;0.05)
        </span>
          <el-select style="width: 200px;float: right;margin-right: 50px"
                     v-model="gene_list_source.selectedSpatialDEGene"
                     @change="changeSelectedSpatialDEGene"
                     clearable
                     filterable
                     size="mini"
                     :filter-method="filterMethod_spatialde"
                     v-el-select-loadmore="loadMore_spatialde"
                     @visible-change="visibleChange_spatialde"
                     placeholder="gene search">
            <el-option
                v-for="item in gene_list_source.gene_list_spatial_options.slice(0, gene_list_source.rangeNumber_spatialde)"
                :key="item.gene"
                :label="item.gene"
                :value="item.gene">
            </el-option>
          </el-select>
        </h3>
        <el-table
            height="300"
            fit
            stripe
            :row-style="{height: '10px'}"
            :cell-style="{padding: '0', color: 'black', margin: '0'}"
            :header-cell-style="{padding: '0', margin: '0', fontSize: '10px', color: 'black'}"
            :data="SpatialDE.slice((currentPage1-1)*pageSize1,currentPage1*pageSize1)">
          <el-table-column
              label="ID"
              type="index"
              width="80">
            <template scope="scope">
              <span>{{(currentPage1 - 1) * pageSize1 + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gene" label="GENE" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="SAMPLE" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="p" label="P_VALUE" sortable :formatter="rounding" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="q" label="Q_VALUE" sortable :formatter="rounding" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-pagination align='center' @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                       :current-page="currentPage1"
                       :page-sizes="[15,20,50,100]"
                       :page-size="pageSize1"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="SpatialDE.length">
        </el-pagination>
      </div>
      <div v-show="this.TrendSceek.length !== 0">
        <h3>
          <span>SV genes identified by trendsceek(Q-value	&lt;0.05)</span>
          <el-select style="width: 200px;float: right;margin-right: 50px"
                     v-model="gene_list_source.selectedTrendsceekGene"
                     @change="changeSelectedTrendSceekGene"
                     clearable
                     filterable
                     size="mini"
                     :filter-method="filterMethod_trendsceek"
                     v-el-select-loadmore="loadMore_trendsceek"
                     @visible-change="visibleChange_trendsceek"
                     placeholder="gene search">
            <el-option
                v-for="item in gene_list_source.gene_list_trendsceek_options.slice(0, gene_list_source.rangeNumber_trendsceek)"
                :key="item.gene"
                :label="item.gene"
                :value="item.gene">
            </el-option>
          </el-select>
        </h3>
        <el-table
            height="300"
            stripe
            :data="TrendSceek.slice((currentPage2-1)*pageSize2,currentPage2*pageSize2)"
            :row-style="{height: '10px'}"
            :cell-style="{padding: '0', color: 'black', margin: '0'}"
            :header-cell-style="{padding: '0', margin: '0', fontSize: '10px', color: 'black'}">
          <el-table-column
              label="ID"
              type="index"
              width="80">
            <template scope="scope">
              <span>{{(currentPage2 - 1) * pageSize2 + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gene" label="GENE" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="SAMPLE" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="qval_emark" label="Q-VALUE(Emark)" sortable :formatter="rounding2" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="qval_vmark" label="Q-VALUE(Vmark)" sortable :formatter="rounding2" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="qval_corr" label="Q-VALUE(MarkCorr)" sortable :formatter="rounding2" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="qval_markvario" label="Q-VALUE(MarkVario)" sortable :formatter="rounding2" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-pagination align='center' @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
                       :current-page="currentPage2"
                       :page-sizes="[15,20,50,100]"
                       :page-size="pageSize2"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="TrendSceek.length">
        </el-pagination>
      </div>
    </div>
    <div id="dataset_svg_enrichment">
      <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="handleClick"
          style="margin-top: 10px;color: black" >
        <el-tab-pane label="GO enrichment analysis(SpatialDE)" v-if="img_exist.spgo" name="first">
          <div v-for="(item,index) in img.spgoimg" :key="index" id="sp_go">
            <div v-show="CheckImgExists(item.path)">
              <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
              <img :src=item.path width="80%"  alt="pic load error">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="KEGG enrichment analysis(SpatialDE)" v-if="img_exist.spkegg" name="second">
          <div v-for="(item,index) in img.spkeggimg" :key="index" id="sp_kegg">
            <div v-show="CheckImgExists(item.path)">
              <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
              <img :src=item.path width="80%"  alt="pic load error">
            </div>
          </div>
          <!--          <img :src=imgPath[2] style="width: 80%" alt=""/>-->
        </el-tab-pane>
        <el-tab-pane label="GO enrichment analysis(trendsceek)" v-if="img_exist.trendsceekgo" name="third">
          <div v-for="(item,index) in img.trendsceekgoimg" :key="index" id="trendsceek_go">
            <div v-show="CheckImgExists(item.path)">
              <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
              <img :src=item.path width="80%"  alt="pic load error">
            </div>
          </div>
          <!--          <img :src=imgPath[4] style="width: 80%" alt=""/>-->
        </el-tab-pane>
        <el-tab-pane label="KEGG enrichment analysis(trendsceek)" v-if="img_exist.trendsceekkegg" name="forth">
          <div v-for="(item,index) in img.trendsceekkeggimg" :key="index" id="trendsceek_kegg">
            <div v-show="CheckImgExists(item.path)">
              <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
              <img :src=item.path width="80%"  alt="pic load error">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="GO enrichment analysis(SpatialDE)" v-if="img_exist.spgopath" name="fifth">
          <div v-for="(item,index) in img.spgopathimg" :key="index" id="sp_go_path">
            <div v-show=" item.path !== ''">
              <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
              <img :src=item.path width="60%"  alt="pic load error">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="KEGG enrichment analysis(SpatialDE)" v-if="img_exist.spkeggpath" name="sixth">
          <div v-for="(item,index) in img.spkeggpathimg" :key="index" id="sp_kegg_path">
            <div v-show="CheckImgExists(item.path)">
              <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
              <img :src=item.path width="60%"  alt="pic load error">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="GO enrichment analysis(trendsceek)" v-if="img_exist.trendsceekgopath" name="seventh">
          <div v-for="(item,index) in img.trendsceekgopathimg" :key="index" id="trendsceek_go_path">
            <div v-show="CheckImgExists(item.path)">
              <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
              <img :src=item.path width="60%"  alt="pic load error">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="KEGG enrichment analysis(trendsceek)" v-if="img_exist.trendsceekkeggpath" name="eighth">
          <div v-for="(item,index) in img.trendsceekkeggpathimg" :key="index"  id="trendsceek_kegg_path">
            <div v-show="CheckImgExists(item.path)">
              <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
              <img :src=item.path width="60%"  alt="pic load error">
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

</template>

<script>
import * as echarts from "echarts/core";
import 'echarts/lib/component/grid'
import {
  DatasetComponent,
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  TransformComponent
} from 'echarts/components';
import { ScatterChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import Vue from "vue";
import {_debounce} from "@/util/debounce";
import MyGridLayout from "@/components/tools/MyGridLayout";

echarts.use([
  DatasetComponent,
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  TransformComponent,
  ScatterChart,
  CanvasRenderer,
  UniversalTransition
]);
export default {
  name: "Dataset_SVG_grid",
  components: {MyGridLayout},
  data(){
    return{
      isGridShow: false,
      layoutData: [
        // { x: 0, y: 0, w: 4, h: 15, i: "0", type: "MarkerCard", data:{datasetID: '', Array: ''} },
      ],
      index: 0,
      position: [],
      groundtruth_source: '',
      echart_info: {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      },
      formData: {
        datasetID: '',
        Array:  '',
        Type: '',
        Gene: [],
      },
      gene_list_source: {
        selectedSpatialDEGene: '',
        selectedTrendsceekGene: '',
        spatialDE: [],
        trendsceek: [],
        gene_list_spatial_options: [],
        gene_list_trendsceek_options: [],
        rangeNumber_spatialde: 100,
        rangeNumber_trendsceek: 100,
      },
      //table
      SpatialDE: [],
      currentPage1: 1, // 当前页码
      total1: 100, // 总条数
      pageSize1: 15, // 每页的数据条数
      TrendSceek: [],
      currentPage2: 1, // 当前页码
      total2: 100, // 总条数
      pageSize2: 15, // 每页的数据条数
      //enrichment
      activeName: 'first',
      img:{
        spgoimg: [],
        spkeggimg: [],
        trendsceekgoimg: [],
        trendsceekkeggimg: [],
        spgopathimg: [],
        spkeggpathimg: [],
        trendsceekgopathimg: [],
        trendsceekkeggpathimg: [],
      },
      img_exist: {
        spgo: true,
        spkegg: true,
        trendsceekgo: true,
        trendsceekkegg: true,
        spgopath: true,
        spkeggpath: true,
        trendsceekgopath: true,
        trendsceekkeggpath: true,
      },
    }
  },
  provide() {
    return {
      addNewCardMethod: this.addNewCardHandle,
    };
  },
  props:{
    asyncData: {
      classification_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      fine_annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      celltype_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      major_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      minor_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      subset_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },

      // type:String,  //类型可以定义
      // default:''  //默认是空值
      // type:Object,  default () {return {}}
    },
    asynGround: String,
    datasetInfo: Array,
    position_main: Array,
  },
  mounted() {
    this.echart_info = this.asyncData
    this.position = this.position_main
    this.groundtruth_source= this.asynGround
    this.formData.datasetID = this.datasetInfo[0].datasetID
    this.formData.Array = this.datasetInfo[0].name
    this.getSVGPic()
    this.$nextTick(function () {
      (async()=>{
        await this.getSVGTablesData()
        this.initLayoutData()
      })();
      // this.initDatasetMarkerGrid()
    })
  },
  directives:{
    'el-select-loadmore':(el, binding) => {
      // console.log(el)
      // console.log(binding)
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
      if(SELECTWRAP_DOM){
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop - 10 <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    },
  },
  methods: {
    changeSelectedSpatialDEGene() {
      let _this = this
      for (let i=0;i<_this.SpatialDE.length;i++) {
        if (_this.SpatialDE[i].gene === _this.gene_list_source.selectedSpatialDEGene){
          let str = "ID is " + (i+1)
          Vue.prototype.$message.success(str)
          _this.currentPage1 = parseInt((i+1) / _this.pageSize1 + 1);
          break
        }
      }
    },
    changeSelectedTrendSceekGene() {
      let _this = this
      for (let i=0;i<_this.TrendSceek.length;i++) {
        if (_this.TrendSceek[i].gene === _this.gene_list_source.selectedTrendsceekGene){
          let str = "ID is " + (i+1)
          Vue.prototype.$message.success(str)
          _this.currentPage2 = parseInt((i+1) / _this.pageSize2 + 1);
          break
        }
      }
    },
    filterMethod_spatialde:_debounce(function(filterVal){
      if(filterVal){
        this.gene_list_source.gene_list_spatial_options = this.gene_list_source.spatialDE.filter((item) => {
          return item.gene.includes(filterVal)
        });
      }else{
        this.gene_list_source.gene_list_spatial_options = this.gene_list_source.spatialDE;
      }
    },500),
    loadMore_spatialde() {
      // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      this.gene_list_source.rangeNumber_spatialde += 20
      // return () => (this.rangeNumber += 100); // 每次滚动到底部可以新增条数  可自定义
    },
    visibleChange_spatialde(flag){
      if(flag){
        this.filterMethod_spatialde()
      }
    },
    filterMethod_trendsceek:_debounce(function(filterVal){
      if(filterVal){
        this.gene_list_source.gene_list_trendsceek_options = this.gene_list_source.trendsceek.filter((item) => {
          return item.gene.includes(filterVal)
        });
      }else{
        this.gene_list_source.gene_list_trendsceek_options = this.gene_list_source.trendsceek;
      }
    },500),
    loadMore_trendsceek() {
      // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      this.gene_list_source.rangeNumber_trendsceek += 20
      // return () => (this.rangeNumber += 100); // 每次滚动到底部可以新增条数  可自定义
    },
    visibleChange_trendsceek(flag){
      if(flag){
        this.filterMethod_trendsceek()
      }
    },
    async getSVGTablesData() {
      let _this = this
      let PromiseA = new Promise((resolve) => {
        _this.$axios.get(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/SVG/spatialDE/'+
            _this.formData.datasetID + '/' + _this.formData.Array)
            .then(function (response){
              // console.log('spatialDE:')
              // console.log(response)
              let temp = response.data.SpatialDE
              for (let i = 0; i<temp.length; i++ ){
                if (temp[i].name === _this.formData.Array){
                  _this.SpatialDE.push(temp[i])
                  _this.gene_list_source.spatialDE.push({'gene': temp[i].gene})
                }
              }
              resolve()
              // console.log(_this.SpatialDE)
            })
      })
      let PromiseB = new Promise((resolve) => {
        _this.$axios.get(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/SVG/trendsceek/'+
            _this.formData.datasetID + '/' + _this.formData.Array)
            .then(function (response){
              // console.log('Trendsceek:')
              // console.log(response)
              let temp = response.data.Trendsceek
              // console.log(temp)
              for (let i = 0; i<temp.length; i++ ){
                if (temp[i].name === _this.formData.Array){
                  _this.TrendSceek.push(temp[i])
                  _this.gene_list_source.trendsceek.push({'gene': temp[i].gene})
                }
              }
              resolve()
              // console.log(_this.TrendSceek)
            })
      })
      await Promise.all([PromiseA, PromiseB])
    },
    rounding(row,column) {
      return parseFloat(row[column.property]).toFixed(19)
    },
    rounding2(row,column) {
      return parseFloat(row[column.property]).toFixed(10)
    },
    handleClick(){},
    handleSizeChange1(val) {
      this.currentPage1 = 1;
      this.pageSize1 = val;
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
    },
    handleSizeChange2(val) {
      this.currentPage2 = 1;
      this.pageSize2 = val;
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
    },
    getSVGPic() {
      let _this = this
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/SVG/img/'+ _this.formData.datasetID + '/' + _this.formData.Array)
          .then(function (response){
            // console.log('img:')
            let resdata=JSON.parse(JSON.stringify(response.data));
            // console.log(resdata)
            _this.img = resdata
            _this.img_exist.spgo = _this.img.spgoimg.length
            _this.img_exist.spkegg = _this.img.spkeggimg.length
            _this.img_exist.trendsceekgo = _this.img.trendsceekgoimg.length
            _this.img_exist.trendsceekkegg = _this.img.trendsceekkeggimg.length
            _this.img_exist.spgopath = _this.img.spgopathimg.length
            _this.img_exist.spkeggpath = _this.img.spkeggpathimg.length
            _this.img_exist.trendsceekgopath = _this.img.trendsceekgopathimg.length
            _this.img_exist.trendsceekkeggpath = _this.img.trendsceekkeggpathimg.length
            // console.log('img_exist:')
            // console.log(_this.img_exist)
          })
    },
    CheckImgExists(imgurl) {
      var ImgObj = new Image(); //判断图片是否存在
      ImgObj.src = imgurl;
      //存在图片
      return ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0);
    },

    initLayoutData(){
      let index = 0
      let temp_layout = []
      if (this.asynGround !== '' || this.asynGround.length !== 0){
        temp_layout.push({
          x: Math.round((index % 3) * 4),
          y:  Math.round(index / 3),
          w: 4,
          h: 15,
          i: 'marker'+index.toString(),
          type: "TruthImageCard",
          data:{
            datasetID: this.formData.datasetID,
            groundtruth_source: this.asynGround
          }
        },)
        index++
      }
      let item;
      for(item in this.echart_info) {
        if (this.echart_info[item].source.length !== 0){
          let info_pic = ''
          switch (item) {
            case 'classification_info':
              info_pic = 'spatial domain';
              break;
            case 'annot_type_info':
              info_pic = 'anno_true';
              break;
            case 'fine_annot_type_info':
              info_pic = 'fine_anno_true';
              break;
            case 'celltype_info':
              info_pic = 'celltype';
              break;
            case 'major_info':
              info_pic = 'celltype_major';
              break;
            case 'minor_info':
              info_pic = 'celltype_minor';
              break;
            case 'subset_info':
              info_pic = 'celltype_subset';
              break;
          }
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: 'svg'+index.toString(),
            type: "InfoCard",
            data:{
              info: this.echart_info[item],
              info_type: info_pic
            },
          },)
          index++;
        }
      }
      temp_layout.push({
        x: Math.round((index % 3) * 4),
        y: Math.round(index / 3),
        w: 4,
        h: 15,
        i: 'svg'+index.toString(),
        type: "SVGCard",
        data:{
          datasetID: this.formData.datasetID,
          array: this.formData.Array,
          position: this.position,
          genes_spatialDE: this.gene_list_source.spatialDE,
          genes_trendsceek: this.gene_list_source.trendsceek
        },
      },)
      index++;
      temp_layout.push({
        x: Math.round((index % 3) * 4),
        y: Math.round(index / 3),
        w: 4,
        h: 15,
        i: 'svg'+index.toString(),
        type: "AddNewCard",
      },)
      index++;

      this.layoutData = temp_layout
      console.log(this.layoutData)
      this.index = index
      this.isGridShow = true
    },
    addNewCardHandle() {
      let index = this.index;
      let temp_json = {
        x: Math.round((index % 3) * 4),
        y: Math.round(index / 3),
        w: 4,
        h: 15,
        i: 'svg'+index.toString(),
        type: "SVGCard",
        data:{
          datasetID: this.formData.datasetID,
          array: this.formData.Array,
          position: this.position,
          genes_spatialDE: this.gene_list_source.spatialDE,
          genes_trendsceek: this.gene_list_source.trendsceek
        },
      };
      index++;
      this.index = index
      this.layoutData.splice(index-1, 0, temp_json)
      console.log(this.layoutData)
    },
  },
}
</script>

<style scoped>
#dataset_svg_pic{
  /*height: 500px;*/
  width: 1350px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
}
.left{
  height: 450px;
  width: 900px;
  /*overflow-x: auto;*/
  /*overflow-y: auto;*/
  z-index: 0;
}
.right{
  height: 450px;
  /*flex: 1;*/
  width: 450px;
  /*overflow-x: auto;*/
  overflow-y: auto;
  z-index: 99;
}
</style>
